import * as types from './types';

export const mutations = {
  [types.DTGPTChats.SET.ALL](state, payload) {
    state.chats = payload;
  },

  [types.SET_SHOW_CHATS](state, payload) {
    state.showGPTChat = payload;
  },
}